module.exports = __webpack_public_path__ + "img/external-link.82a644d7.svg";